import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

import { ConversationSidebarItemId } from '../../conversationSidebar.types';
import { conversationSidebarConfig } from '../../utils/conversationSidebarItems';

import styles from './conversationSidebarButton.module.scss';

type ConversationSidebarItemProps = {
  /** The sidebar id. */
  sidebarId: ConversationSidebarItemId;
  /** Whether the item is active. */
  isActive?: boolean;
} & Pick<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  'onClick'
>;

/** Represents the conversation sidebar button. */
export const ConversationSidebarButton = ({
  sidebarId,
  isActive,
  onClick,
}: ConversationSidebarItemProps): JSX.Element => {
  const { icon } = conversationSidebarConfig[sidebarId];
  const classNames = classnames(styles.root, { [styles.isActive]: isActive });

  return (
    <button className={classNames} onClick={onClick}>
      <Icon name={icon} />
    </button>
  );
};
